import { EmpathizeLayout, EmpathizeLayoutItem, EmpathizeState } from '../../../models';
import { GETTERS_KEYS } from '../../store.const';
import { RootStoreState } from '../../store.interfaces';
import { EMPATHIZE_GETTERS_KEYS } from '../empathize.const';
import { EmpathizeGetter } from '../empathize.interfaces';

export class ShowEmpathizeOpenGetter implements EmpathizeGetter {
  getters = {
    [EMPATHIZE_GETTERS_KEYS.showOpen]:
      (empathizeState: EmpathizeState, getters: any, rootState: RootStoreState, rootGetters: any): boolean => {
        const hasContent = this.hasEmpathizeContent(getters, rootGetters);
        return rootState.core.openFinished && rootState.core.openEmpathize && (hasContent || empathizeState.loading);
      }
  };

  private hasEmpathizeContent(getters: any, rootGetters: any): boolean {
    const layout: EmpathizeLayout = getters[EMPATHIZE_GETTERS_KEYS.layout];
    return layout.some((layoutRow: EmpathizeLayoutItem[]) =>
      layoutRow.some((layoutItem: EmpathizeLayoutItem) =>
        layoutItem.getter === GETTERS_KEYS.history.queryHistory || rootGetters[layoutItem.getter].length));
  }
}
